import { render, staticRenderFns } from "./iphone.vue?vue&type=template&id=45b0a2bd&"
var script = {}
import style0 from "./iphone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports